import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import {
    Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Sector
} from 'recharts';
import CustomLegendIcon from './legendicon';
import { Typography } from '@material-ui/core'
const COLOR_PATTERNS = ['#4285F4', '#D65140', '#8254A9', '#34A853', '#F6B646', '#284C88'];
const useStyles = makeStyles(() => ({
    root: {
        position: 'relative',
    },
}));

const Chart = props => {
    const { loading, data, title, className, innerRadius, ...rest } = props;
    const [activeIndex, setActiveIndex] = useState(0)
    const classes = useStyles();

    const dataProp = data.map((item, index) => ({
        name: item.label,
        value: item.value,
        fill: COLOR_PATTERNS[index % COLOR_PATTERNS.length],
    }))
    const legendList = data.map((item, index) => ({
        value: item.label,
        color: COLOR_PATTERNS[index % COLOR_PATTERNS.length],
        legendIcon: < CustomLegendIcon fill={COLOR_PATTERNS[index % COLOR_PATTERNS.length]} />
    }))
    const content = (props) => {
        const data = dataProp[props.label]
        if (data)
            return <Typography style={{ backgroundColor: 'white', padding: 10, borderRadius: 4, boxShadow: '0px 8px 35px rgba(6, 56, 63, 0.1)' }}> {`${dataProp[props.label].name}: ${dataProp[props.label].value}`}</Typography>
        return ''
    }
    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Typography variant='h6' style={{ textAlign: 'center' }}><strong>{title}</strong></Typography>
            {
                !loading &&
                <ResponsiveContainer>
                    <PieChart width={400} height={400}>
                        <Pie
                            activeIndex={activeIndex}
                            activeShape={renderActiveShape}
                            data={data}
                            cx="50%"
                            cy="50%"
                            innerRadius={60}
                            outerRadius={80}
                            fill="#8884d8"
                            dataKey="value"
                            onMouseEnter={(_, index) => {
                                setActiveIndex(index)
                            }}
                        >
                            {
                                data.map((entry, index) => <Cell key={dataProp[index].name} fill={COLOR_PATTERNS[index % COLOR_PATTERNS.length]} />)
                            }
                        </Pie>
                        <Tooltip data content={content} payload={legendList} />
                    </PieChart>
                </ResponsiveContainer>
            }
        </div>
    );
};

Chart.propTypes = {
    className: PropTypes.string,
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    title: PropTypes.any,
    innerRadius: PropTypes.any,
    label: PropTypes.any
};
function areEqual(prevProps, nextProps) {
    if (prevProps.data != nextProps.data || prevProps.title != nextProps.title) return false
    return true
}
export default React.memo(Chart, areEqual);
const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, value, label } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
        <g>
            <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
                {payload.name}
            </text>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
            />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={outerRadius + 6}
                outerRadius={outerRadius + 10}
                fill={fill}
            />
            <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
            <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
            <text x={ex + (cos >= 0 ? 1 : -1) * 4} y={ey + 3} textAnchor={textAnchor} fill={fill} fontSize="0.7em">{`${label}: ${value}`}</text>
        </g>
    );
};